module.exports = __webpack_public_path__ + "static/media/dad.fae8b872.jpeg";